import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import Box from '~/core/Box'

import { BoxPropsType } from './Box/type'

interface LoadingSpinnerPropsType extends BoxPropsType {
    variant?: 'outlined'
}

const LoadingSpinner = (props: LoadingSpinnerPropsType) => {
    const {
        width = '100%',
        height = '90%',
        position = 'relative',
        variant,
        ...rest
    } = props

    let Spinner = <Spin />

    if (variant === 'outlined') {
        const antIcon = (
            <LoadingOutlined
                style={{ fontSize: 24 }}
                spin
                color="rgba(0, 0, 0, 0.65)"
            />
        )

        Spinner = (
            <Spin
                indicator={antIcon}
                style={{ color: 'rgba(0, 0, 0, 0.65)' }}
            />
        )
    }

    return (
        <Box
            alignItems="center"
            justifyContent="center"
            height={height}
            width={width}
            position={position}
            {...rest}
        >
            {Spinner}
        </Box>
    )
}

export default LoadingSpinner
